/** Задания дня — подключение к стору и колбэкам. */
import type { WindowProps } from "../kit";
import { TasksView } from "./view";
import { appStore, useStore, registerWindow } from "../../../app";
import { actions } from "../actions";
import { dailyTasksClaimable } from "@newfungame/engine";
import { playSound } from "../../../audio";
import { useEffect, useState } from "preact/hooks";

declare module "../../../app/state/window-route" {
  interface WindowRoutes {
    tasks: object;
  }
}

/** Секунд до новых заданий по часам сервера; окно обновляет их раз в полминуты. */
function useSecondsTo(at: number | null): number {
  const offset = useStore(appStore, (s) => s.clockOffset);
  const [, tick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => tick((n) => n + 1), 30_000);
    return () => clearInterval(id);
  }, []);
  return at === null ? 0 : Math.max(0, Math.ceil((at - Date.now() - offset) / 1000));
}

export function Tasks({ close }: WindowProps<"tasks">) {
  const tasks = useStore(appStore, (s) => s.player?.tasks ?? null);
  const seconds = useSecondsTo(tasks?.resetsAt ?? null);
  useEffect(() => {
    if (tasks) actions().tasksOpened(dailyTasksClaimable(tasks).length);
  }, []);
  if (!tasks) return null;
  return (
    <TasksView
      tasks={tasks}
      claimable={dailyTasksClaimable(tasks)}
      secondsLeft={seconds}
      onClaim={(task) => {
        playSound("purchase");
        actions().claimTask(task);
      }}
      onClose={close}
    />
  );
}

export function register(): void {
  registerWindow("tasks", Tasks);
}
